function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeFixedCost, makeRangeCost, makeVariableCost } from "./makers.ts";
import { ServiceCostType } from "./model";
import * as selectors from "./selectors";
export function setPriceIncrease(cost, priceIncrease) {
  return _objectSpread(_objectSpread({}, cost), {}, {
    priceIncrease
  });
}
export function setPreapprovedAmount(cost, amount, controlledByAdvancedSettings) {
  if (cost.pricingType === ServiceCostType.Variable) {
    return _objectSpread(_objectSpread({}, cost), {}, {
      unitCap: amount
    }, controlledByAdvancedSettings ? {
      preapprovedControlledByAdvancedSettings: true
    } : {
      preapprovedControlledByAdvancedSettings: false
    });
  }
  return cost;
}
export function setDiscount(cost, discount) {
  return _objectSpread(_objectSpread({}, cost), {}, {
    discount
  });
}
export function setPrice(cost, newCost) {
  switch (cost.pricingType) {
    case ServiceCostType.Fixed:
    case ServiceCostType.Variable:
      return _objectSpread(_objectSpread({}, cost), {}, {
        price: selectors.price(newCost)
      });
    case ServiceCostType.Range:
      return _objectSpread(_objectSpread({}, cost), {}, {
        maxPrice: selectors.price(newCost),
        minPrice: selectors.minPrice(newCost)
      });
  }
}
export function setPrice2(cost, price) {
  switch (cost.pricingType) {
    case ServiceCostType.Fixed:
    case ServiceCostType.Variable:
      return _objectSpread(_objectSpread({}, cost), {}, {
        price
      });
    case ServiceCostType.Range:
      return _objectSpread(_objectSpread({}, cost), {}, {
        maxPrice: price,
        minPrice: cost.minPrice
      });
  }
}
export function inputCostDataToModel(_ref) {
  let {
    pricing,
    price,
    minPrice,
    discount,
    priceIncrease,
    unitCap,
    unitName
  } = _ref;
  switch (pricing) {
    case ServiceCostType.Fixed:
      return makeFixedCost(price, {
        discount,
        priceIncrease
      });
    case ServiceCostType.Range:
      return makeRangeCost(price, {
        minPrice: minPrice ? +minPrice : null,
        discount,
        priceIncrease
      });
    default:
      return makeVariableCost(price, {
        discount,
        unitName: pricing === 'unit' && unitName || null,
        unitCap: unitCap ? +unitCap : 0,
        priceIncrease
      });
  }
}